'use client';

import { useCallback, useEffect, useRef } from 'react';

export function useResumeEnglishIqCompletion(
  token: string | null,
  finish: (token?: string) => Promise<void>,
): (token?: string) => Promise<void> {
  const attemptedToken = useRef<string | null>(null);
  const attemptCompletion = useCallback(
    async (nextToken?: string): Promise<void> => {
      if (!nextToken) {
        return;
      }
      attemptedToken.current = nextToken;
      await finish(nextToken);
    },
    [finish],
  );

  useEffect(() => {
    if (!token) {
      attemptedToken.current = null;
      return;
    }
    if (attemptedToken.current === token) {
      return;
    }
    void attemptCompletion(token);
  }, [attemptCompletion, token]);

  return attemptCompletion;
}
